/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IHeaderViewProps } from './header';

const headerView: React.FC<IHeaderViewProps> = props => {
    const {
        HeaderTag,
        HeaderContainer,
        HeaderTopBarContainer,
        HeaderBottomBarContainer,
        MobileMenuContainer,
        MobileMenuBodyContainer,
        MobileMenuLinksContainer,
        Divider,
        TierDivider,
        isRetailB2BContactMultiOutletOrderingFeatureEnabled
    } = props;
    return (
        <Module {...HeaderTag}>
            <Node {...HeaderContainer}>
                <Node {...HeaderTopBarContainer}>
                    {props.navIcon}
                    {props.logo}
                    {props.fitmentSearchBtn}
                    {_renderReactFragment(props.search)}
                    {!isRetailB2BContactMultiOutletOrderingFeatureEnabled && (
                        <>
                            {props.preferredStore}
                            {props.currentDistributor}
                        </>
                    )}
                    {_renderDesktopAccountBlock(props)}
                    {props.wishListIconDesktop}
                    <Node {...Divider} />
                    {props.cartIcon}
                    {_renderReactFragment(props.siteOptions)}
                </Node>
                {isRetailB2BContactMultiOutletOrderingFeatureEnabled && (
                    <>
                        {TierDivider && Object.keys(TierDivider).length > 0 && <Node {...TierDivider} />}
                        {HeaderBottomBarContainer && Object.keys(HeaderBottomBarContainer).length > 0 && (
                            <Node {...HeaderBottomBarContainer}>
                                {props.preferredStore}
                                {props.currentDistributor}
                            </Node>
                        )}
                    </>
                )}
                <Node {...MobileMenuContainer}>
                    <Node {...MobileMenuBodyContainer}>
                        {props.MobileMenuHeader}
                        {_renderReactFragment(props.menuBar)}
                        <Node {...MobileMenuLinksContainer}>
                            {props.accountLinks ? props.accountLinks.map(link => link) : false}
                            {props.siteOptions}
                            {props.wishListIconMobile}
                            {props.signInLink}
                            {props.signOutLink}
                        </Node>
                    </Node>
                </Node>
                {_renderReactFragment(props.menuBar)}
            </Node>
        </Module>
    );
};

function _renderDesktopAccountBlock(props: IHeaderViewProps): JSX.Element | null {
    const {
        AccountInfoDropdownParentContainer,
        AccountInfoDropdownPopoverConentContainer,
        accountInfoDropdownButton,
        MyAccountDropdownParentContainer,
        MyAccountInfoDropdownButton,
        MyAccountDropdownPopoverConentContainer,
        signOutLink,
        signInLink,
        accountLinks
    } = props;

    if (AccountInfoDropdownParentContainer) {
        if (AccountInfoDropdownPopoverConentContainer) {
            return (
                <Node {...AccountInfoDropdownParentContainer}>
                    {accountInfoDropdownButton}
                    <Node {...AccountInfoDropdownPopoverConentContainer}>
                        {accountLinks ? accountLinks.map(link => link) : false}
                        {signOutLink}
                    </Node>
                </Node>
            );
        } else if (signInLink) {
            if(MyAccountDropdownParentContainer)
            {
                if(MyAccountDropdownPopoverConentContainer)
                {
                    return (
                        <Node {...MyAccountDropdownParentContainer}>
                             {MyAccountInfoDropdownButton}
                            <Node {...MyAccountDropdownPopoverConentContainer}>
                                { signInLink ? signInLink.map(link => link) : false }
                            </Node>
                        </Node>
                    );
                }
            }
        }
    }
    props.context.telemetry.error('Header content is empty, module wont render.');
    return null;
}

function _renderReactFragment(items: React.ReactNode[]): JSX.Element | null {
    return (
        <>
            {items && items.length > 0
                ? items.map((slot: React.ReactNode, index: number) => {
                      return <React.Fragment key={index}>{slot}</React.Fragment>;
                  })
                : null}
        </>
    );
}

export default headerView;
